module.exports = __webpack_public_path__ + "static/media/workshop1.0a80199a.jpg";